import { render } from "./RemoveEntitlementsModal.vue?vue&type=template&id=e9befcf4&ts=true"
import script from "./RemoveEntitlementsModal.vue?vue&type=script&lang=ts"
export * from "./RemoveEntitlementsModal.vue?vue&type=script&lang=ts"

import "./RemoveEntitlementsModal.vue?vue&type=style&index=0&id=e9befcf4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__